<!-- 智能合同页面 -->
<template>
    <div class="ai-contract">
        <div class="title">
            AI合同助手
            <span class="tip">由百度AI提供创作能力</span>
        </div>
        <veui-tabs
            class="ai-contract-tabs"
            ui="l"
            :active.sync="curTab"
            @change="tabChange"
        >
            <veui-tab
                v-for="(item, index) in visibleTabList"
                :key="index"
                :name="item.name"
            >
                <div slot="label" class="tab-item">
                    {{ item.label }}
                    <span v-if="item.isNew" class="new-badge"></span>
                </div>
            </veui-tab>
        </veui-tabs>
        <generate-page v-show="curTab === 'generate'"/>
        <history-page
            v-show="curTab === 'history'"
            ref="history"
            :show="curTab === 'history'"
        />
    </div>
</template>

<script>
/**
 * @file index.vue
 * @desc 智能合同
 * @author xingminghua@baidu.com
 */
import {mapState, mapMutations} from 'vuex';
import {Tabs, Tab} from 'veui';
import Generate from './generate';
import History from './history';
import {checkLatestUnread} from '../util';

export default {
    name: 'ai-contract',
    components: {
        'veui-tabs': Tabs,
        'veui-tab': Tab,
        'generate-page': Generate,
        'history-page': History
    },
    data() {
        return {
            // 当前选中的是哪个tab
            curTab: 'generate',
            tabList: [
                {
                    label: '生成合同',
                    name: 'generate',
                    logArea: 'scht-tab'
                },
                {
                    label: '历史记录',
                    name: 'history',
                    logArea: 'lsjl-tab',
                    isNew: false
                }
            ],
            isHideHistory: true
        };
    },
    computed: {
        ...mapState({
            latestId: state => state.Service.aiContract.latestId
        }),
        // 没有历史记录时，隐藏历史记录tab
        visibleTabList() {
            return this.tabList.filter(item => {
                const {name} = item;
                if (name === 'history' && !this.latestId) {
                    return false;
                }
                return true;
            });
        }
    },
    watch: {
        latestId: {
            handler(val) {
                // 检查是否有未读红点
                if (checkLatestUnread(val) && this.curTab === 'generate') {
                    this.$set(this.tabList[1], 'isNew', true);
                    this.$refs.history?.getList();
                }
            },
            immediate: true
        },
        curTab: {
            handler(val) {
                // 消除红点
                if (val === 'history') {
                    localStorage.setItem('lastReadContractId', this.latestId);
                    this.$set(this.tabList[1], 'isNew', false);
                    this.setBadgeTextValue({
                        routeName: 'AI合同助手',
                        value: ''
                    });
                }
            },
            immediate: true
        }
    },
    methods: {
        ...mapMutations({
            setBadgeTextValue: 'Menu/setBadgeTextValue'
        }),
        tabChange(tab) {
            const {logArea}
                = this.tabList.find(item => item.name === tab.name) || {};
            logArea
                && this.$wywLog.send({
                    serverId: 17047,
                    action: 'click',
                    area: logArea
                });
        }
    }
};
</script>

<style lang='less' scoped>
.ai-contract {
    background: #fff;
    box-shadow: 0 6px 14px 0 rgba(227, 233, 237, .35);
    border-radius: 8px;
    padding: 30px 0;

    .title {
        display: flex;
        align-items: center;
        font-family: PingFangSC-Semibold;
        font-size: 18px;
        color: #333;
        line-height: 18px;
        margin: 0 24px 17px 30px;

        .tip {
            margin-left: auto;
            font-family: PingFangSC-Regular;
            font-size: 14px;
            color: #999;
        }
    }

    .ai-contract-tabs {
        /deep/ .veui-tabs-menu {
            .veui-tabs-item {
                margin: 0 23px;

                &:first-child {
                    margin-left: 30px;
                }
            }

            .veui-tabs-item-label {
                font-family: PingFangSC-Medium;
                font-size: 16px;
                line-height: 16px;
                font-weight: 500;
            }

            .veui-tabs-item-active:not(.veui-disabled) > .veui-tabs-item-label {
                color: #05f;

                &::after {
                    background-color: #05f;
                }
            }

            .veui-tabs-item-label-content .veui-tabs-item-label-ellipsis {
                overflow: visible;
            }
        }

        .tab-item {
            position: relative;
            display: flex;
            align-items: center;

            .new-badge {
                position: absolute;
                width: 7px;
                height: 7px;
                background: #fd503e;
                border-radius: 50%;
                top: -4px;
                right: -7px;
            }
        }
    }
}
</style>